import { Teilimpfungsart } from '@/types/Teilimpfungsart';
import { Satzart } from '@/types/Satzart';
import { Verrechnungsart } from '@/types/Verrechnungsart';
import PatBrief from '@/types/PatBrief';
import PatUntersuchung from '@/types/PatUntersuchung';
import PatRezept from '@/types/PatRezept';
import PatDiagnose from '@/types/PatDiagnose';
import PatAnamnese from '@/types/PatAnamnese';
import {SystemEinstellung, SystemEinstellungKey} from '@/types/Einstellung';
import store from '@/store';

export default class Impfung {
    /** PK: PatImpfung | erforderlich */
    public patimpfung_id: number | null = null;
    /** FK: Patient Verweis auf Tab. Patienten | erforderlich */
    public patnr: number | null = null;
    /** Art des Karteieintrags: 10=Plan, 20=Impfung, 30=Text, 40=Leistung, 50=Untersuchung, 60=Diagnose, 70=Anamnese,
     *  80=Brief, 90=Rezept */
    public satzart: number | null = null;
    /** Impfung nachgetragen j/n | max. 1 Zeichen */
    public nachtrag: string | null = null;
    /** Datensatz von ELGA übernommen j/n | max. 1 Zeichen */
    public elga: string | null = null;
    /** Impfung im EIIS storniert und Storno in ELGA noch offen j/n | max. 1 Zeichen */
    public storniert: string | null = null;
    /** Transfer an ELGA a = aktiv, f = fertig | max. 1 Zeichen */
    public eimpf_transfer: string | null = null;
    /** ID des Impfungseintrags im e-Impfpass | max. 255 Zeichen */
    public eimpf_id: string | null = null;
    /**  | max. 255 Zeichen */
    public eimpf_system: string | null = null;
    /** FK: ErkankungsCode Verweis auf Tab. eImpf_ImpfrelevanteErkrankung_VS (dzt. nicht verwendet) | max. 10 Zeichen */
    public erkrankung_code: string | null = null;
    /** FK: RisikogruppeCode Verweis auf Tab. eImpf_SpecialSituationIndication_VS (dzt. nicht verwendet) | max. 10 Zeichen */
    public risikogruppe_code: string | null = null;
    /** FK: Plan Verweis auf Tab. PatPlaene */
    public patplan_id: number | null = null;
    /** FK: PatPlanImpfstoff Verweis auf Tab. PatPlaeneImpfstoffe */
    public patplanimpfstoff_id: number | null = null;
    /** Texteintrag | max. 255 Zeichen */
    public text: string | null = null;
    /** Dateiname der Datei bei Texteinträgen | max. 255 Zeichen */
    public datei: string | null = null;
    /** FK: Leistung Verweis auf Tab. Leistungen */
    public leistung_id: number | null = null;
    /** FK: PatUntersuchung Verweis auf Tab. PatUntersuchungen */
    public patuntersuchung_id: number | null = null;
    /** FK: PatRezept Verweis auf Tab. PatRezepte */
    public patrezept_id: number | null = null;
    /** FK: PatBrief Verweis auf Tab. PatBriefe */
    public patbrief_id: number | null = null;
    /** FK: PatDiagnose Verweis auf Tab. PatDiagnose */
    public patdiagnose_id: number | null = null;
    /** FK: ImpfgrundCode Verweis auf Tab. eImpf_Impfgrund_VS | max. 10 Zeichen */
    public impfgrund_code: string | null = null;
    /** FK: ImpfungindikationCode Verweis auf Tab. eImpf_ImmunizationTarget_VS | max. 20 Zeichen */
    public impfungindikation_code: string | null = null;
    /** FK: ImpfschemaCode Verweis auf Tab. eImpf_Impfschema_VS | max. 10 Zeichen */
    public impfschema_code: string | null = null;
    /** FK: ImpfstoffCode PZN (Id. in eImpf_Impfstoffe_VS) | max. 20 Zeichen */
    public impfstoff_code: string | null = null;
    /** FK: Impfstoff Verweis auf Tab. Impfstoffe */
    public impfstoff_id: number | null = null;
    /** Impfstoff-Code (Altdaten) | max. 20 Zeichen */
    public impfstoff: string | null = null;
    /** Code der Impfung aus Altsystem | max. 8 Zeichen */
    public impfung_code: string | null = null;
    /** Bezeichnung der Impfung aus Altsystem | max. 50 Zeichen */
    public impfung: string | null = null;
    /** Anzahl verabreichter Impfstoffe */
    public anzahl: number | null = null;
    /** Verweis auf Tab. ImpfstoffChargen */
    public impfstoffcharge_id: number | null = null;
    /** Chargennummer des Impfstoffes (aus ImpfstoffChargen, bzw. Eingabe) | max. 50 Zeichen */
    public chargennr: string | null = null;
    /**  */
    public ablaufdatum: string | null = null;
    /** FK: Verrechnungskennzeichen Verweis auf Tab. Verrechnungskennzeichen (dzt. icht mehr verwendet) */
    public verrechnungs_kz_id: number | null = null;
    /** Lagerabbuchung durchführen j/n | max. 1 Zeichen */
    public lagerbuchung: string | null = null;
    /** Durchführungsdatum der Impfung (akt. Datum), bei Impfungsnachtrag Datum der nachgetragenen Impfung |
     *  erforderlich */
    public impfdatum: string | null = null;
    /** FK: ImpfdosisCode Verweis auf Tab. eImpf_Impfdosis_VS | max. 10 Zeichen */
    public impfdosis_code: string | null = null;
    /** FK: Teilimpfungsnummer Nummer der Teilimpfung (1, 2, 3, 4, etc.) bzw. Auffrischung (9) */
    public teilimpfungsnr: number | null = null;
    /** nächstes Impfdatum (aus Impfabstand in Tab. Teilimpfungen ermittelt) */
    public naechstesimpfdatum: string | null = null;
    /** nächste Teilimpfungsnummer (aus Tab. Teilimpfungen ermittelt) */
    public naechsteteilimpfungsnr: number | null = null;
    /** Impferinnerung bei dieser Impfung gewünscht j/n | max. 1 Zeichen */
    public impferinnerung: string | null = 'n';
    /** nächstes Impfdatum (aus Impfabstand in Tab. Teilimpfungen ermittelt) */
    public erinnerung_gesendet: string | null = null;
    /** Status der Abrechung: 0=keine, 1=zu verrechnen (offen), 2=in Rechnungserstellung, 3=abgrechnet (Rechnung
     *  erstellt) */
    public abrechnung: number | null = null;
    /** FK: Beleg Verweis auf Tab. Belege */
    public beleg_id: number | null = null;
    /** FK: Belegposition Verweis auf Tab. BelegPositionen */
    public belegposition_id: number | null = null;
    /** Verweis auf Tab. Belege Rechnungsjahr (Altdatenübernahme) */
    public jahr: number | null = null;
    /** Verweis auf Tab. Belege lfd. Rechnungsnummer im Jahr (Altdatenübernahme) */
    public belegnr: number | null = null;
    /** Zahlschein, Bar etc. */
    public beleg_zahlungsart: string | null = null;
    /** Datum des Zahlungseingangs */
    public beleg_zahlungseingang: string | null = null;
    /** j/n */
    public beleg_storniert: string | null = 'n';
    /** Verweis auf Tab. BelegPositionen lfd. Rechnungsposition am Beleg (Altdatenübernahme) */
    public posnr: number | null = null;
    /** FK: Impfstelle Verweis auf Tab. Impfstellen */
    public impfstelle_id: number | null = null;
    /** Arzt (Altdatenübernahme) bzw. Impfstelle/Arzt von ELGA | max. 255 Zeichen */
    public arzt: string | null = null;
    /** FK: User Verweis auf Tab. fw_users, eintragende Person (Helfer) */
    public user_id_eintrag: number | null = null;
    /** FK: User Verweis auf Tab. fw_users, nachtragende Person (Arzt, Helfer) */
    public user_id_nachtr: number | null = null;
    /** FK: Person Verweis auf Tab. Personen, durchführende Person (Arzt) */
    public person_id_durchf: any | null = null;
    /** FK: Person Verweis auf Tab. Personen, verantwortliche Person (Impfstellenleitung) */
    public person_id_verantw: number | null = null;
    /** Verweis auf Tab. Personen, verantwortliche Person (Impfstellenleitung) */
    public person_id_helfer: number | null = null;
    /** Id. der Datenübermittlung an Impfdatenbank der Akademie f. Vorsorgemedizin */
    public impfdb_logid: number | null = null;
    /**  */
    public patientengruppe_id: number | null = null;
    /** max 1 Zeichen | j/n */
    public risikopatient : string | null = null;
    /** Impfung als HCW verrechnen|  max 1 Zeichen | j/n */
    public hcw: string | null = null;
    /** max 1 Zeichen | j/n */
    public hcw_student: string | null = null;
    /**  */
    public diagnose_id: number | null = null;
    /**  */
    public patanamnese_id: number | null = null;
    /** max 1 Zeichen | j/n */
    public fremdimpfung: string | null = null;
    /** max 1 Zeichen | Fremdimpfung laut: I=Impfpass, K=Kooperationspartner, P=Patient */
    public fremdimpfungsinfo: string | null = null;
    /** max 1 Zeichen | j/n */
    public impfstoff_mitgebracht: string | null = null;
    /** max 1 Zeichen | j/n */
    public aufklaerung_nebenwirkungen: string | null = null;
    /** max 1 Zeichen | j/n */
    public seite_links: string | null = null;
    /** max 1 Zeichen | j/n */
    public seite_rechts: string | null = null;
    /**  */
    public impfaktion_id: number | null = null;
    /**  */
    public studie_id: number | null = null;
    /** */
    public impfsetting_setting_code: string | null = null;

    public bezeichnung: string | null = null;
    public impfstoffcharge_chargennr: number | null = null;
    public impfstoffcharge_ablaufdatum: string | null = null;
    public impfstelle_bezeichnung: string | null = null;
    public impfstelle_abkuerzung: string | null = null;
    public impfsetting_displayname: string | null = null;
    public impfdosis_teilimpfung: string | null = null;
    public impfdosis_beschreibung: string | null = null;
    public impfdosis_impfdosis_code: string | null = null;
    public naechsteimpfdosis_teilimpfung: string | null = null;
    public naechsteimpfdosis_beschreibung: string | null = null;
    public immunization_displayname: string | null = null;
    public erk_displayname: string | null = null;
    public impfstoff_bezeichnung: string | null = null;
    public impfstoff_impfstoff: string | null = null;
    public impfstoff_impfung: string | null = null;
    public impfstoff_verkaufspreis: string | null = null;
    public risiko_displayname: number | null = null;
    public verkaufspreis: string | null = null;
    public aerzte_arzt: string | null = null;
    public reiseziel: string | null = null;
    public leistung_bezeichnung: string | null = null;
    public leistung_preis: number | null = null;
    public reiseziele: string | null = null;
    public reiseart: string | null = null;
    public rezept: PatRezept | null = null;
    public brief: PatBrief | null = null;
    public diagnose: any = new PatDiagnose();
    public anamnese: any = new PatAnamnese();
    public untersuchung: PatUntersuchung | null = null;
    public elga_displayname: string | null = null;
    public elga_impfstoff_displayname: string | null = null;
    public elga_impfschema_code_displayname: string | null = null;
    public elga_impfstoff_code: string | null = null;
    public elga_impfung_01_code: string | null = null;
    public helfer_arzt: string | null = null;
    public plan_reiseart: string | null = null;
    public plan_abreisedatum: string | null = null;
    public plan_reisedauer: string | null = null;
    public plan_koerpergewicht: string | null = null;
    public plan_koerpergroesse: string | null = null;
    public plan_bemerkungen: string | null = null;
    public plan_arzt: string | null = null;
    public beleg_belegnr: number | null = null;
    public beleg_jahr: number | null = null;
    public leistung_id_inkludiert: number | null = null;
    public patdiagnose_hauptdiagnose: string | null = null;
    public patdiagnose_haupt_patdiagnose_id: number | null = null;
    public patdiagnose_diagnose_id: number | null = null;
    public patdiagnose_immunsupression: string | null = null;
    public nebendiagnosen_namen: string | null = null;
    public patdiagnose_diagnose: string | null = null;
    public nebendiagnosen: any[] = [];

    constructor(impfung?: Partial<Impfung>) {
        Object.assign(this, impfung);

        switch (this.satzart) {
            case Satzart.Untersuchung:
                this.untersuchung = new PatUntersuchung(this.untersuchung);
                break;
            case Satzart.Brief:
                this.brief = new PatBrief(this.brief);
                break;
            case Satzart.Rezept:
                this.rezept = new PatRezept(this.rezept);
                break;
            case Satzart.Diagnose:
                this.diagnose = new PatDiagnose(this.diagnose);
                break;
            case Satzart.Anamnese:
                this.anamnese = new PatAnamnese(this.anamnese);
                break;
        }
    }

    public get isEinfachimpfung(): boolean {
        return this.teilimpfungsnr === Teilimpfungsart.Einfachimpfung;
    }

    public get isTeilimpfung(): boolean {
        return this.impfdosis_teilimpfung === 'j' ||
            this.teilimpfungsnr === Teilimpfungsart.Teilimpfung1 ||
            this.teilimpfungsnr === Teilimpfungsart.Teilimpfung2 ||
            this.teilimpfungsnr === Teilimpfungsart.Teilimpfung3 ||
            this.teilimpfungsnr === Teilimpfungsart.Teilimpfung4;
    }

    public get isAuffrischung(): boolean {
        return this.teilimpfungsnr === Teilimpfungsart.Auffrischung ||
            this.teilimpfungsnr === Teilimpfungsart.AuffrischungsSerieTeil1 ||
            this.teilimpfungsnr === Teilimpfungsart.AuffrischungsSerieTeil2;
    }

    public get isPlan(): boolean {
        return this.satzart === Satzart.Plan;
    }

    public get isImpfung(): boolean {
        return this.satzart === Satzart.Impfung;
    }

    public get isLeistung(): boolean {
        return this.satzart === Satzart.Leistung;
    }

    public get isText(): boolean {
        return this.satzart === Satzart.Text;
    }

    public get isUntersuchung(): boolean {
        return this.satzart === Satzart.Untersuchung;
    }

    public get isDiagnose(): boolean {
        return this.satzart === Satzart.Diagnose;
    }

    public get isAnamnese(): boolean {
        return this.satzart === Satzart.Anamnese;
    }

    public get isBrief(): boolean {
        return this.satzart === Satzart.Brief;
    }

    public get isRezept(): boolean {
        return this.satzart === Satzart.Rezept;
    }

    public get isOffeneRechnung(): boolean {
        const getSystemEinstellung: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T> =
            store.getters['authentication/getSystemEinstellung'];

        return this.abrechnung === Verrechnungsart.Offen || 
            (getSystemEinstellung('zahlungseingang').isEnabled() &&
            this.beleg_zahlungsart === 'Zahlschein' && 
            this.beleg_zahlungseingang === null && 
            this.beleg_storniert !== 'j');
    }

    public get isInBearbeitung(): boolean {
        return this.abrechnung === Verrechnungsart.InBearbeitung;
    }

    public get isZuVerrechnen(): boolean {
        return this.abrechnung !== Verrechnungsart.NichtVerrechenbar;
    }

    public get isNachtrag(): boolean {
        return this.nachtrag === 'j';
    }

    public get isElgaImpfung(): boolean {
        return this.elga === 'j';
    }

    public get isInTransfer(): boolean {
        return this.eimpf_transfer === 'j';
    }

    public get isInStornierung(): boolean {
        return this.storniert === 'j';
    }
}
